import React from "react";
import { closeToast } from "../../store/slices/toast/toastSlice";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const CustomToast = () => {
  const dispatch = useDispatch();
  const { isOpen, text, color } = useSelector((state) => state.toastSlice);
  return (
    <Snackbar
      autoHideDuration={4000}
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        dispatch(closeToast());
      }}
    >
      <Alert variant="filled" color={color}>
        {text}
      </Alert>
    </Snackbar>
  );
};

export default CustomToast;
